<template>
  <div class="cashier-desktop cashier-desktop--ysf">
    <div class="cashier-desktop__shell cashier-desktop__shell--split">
      <aside class="cashier-desktop__overview">
        <div class="cashier-desktop__badge">
          <span class="cashier-desktop__badge-dot"></span>
          云闪付
        </div>
        <div class="cashier-desktop__amount">¥{{ formattedAmount }}</div>
        <h1 class="cashier-desktop__title">{{ payOrderInfo.subject || '云闪付支付订单' }}</h1>
        <div class="cashier-desktop__subtitle">{{ merchantName || '商户信息加载中' }}</div>
        <div v-if="payStatusText" class="cashier-desktop__status-chip">{{ payStatusText }}</div>

        <div class="cashier-desktop__overview-grid">
          <div class="cashier-desktop__meta-card">
            <div class="cashier-desktop__meta-label">订单号</div>
            <div class="cashier-desktop__meta-value">{{ payOrderInfo.payOrderId || '--' }}</div>
          </div>
          <div class="cashier-desktop__meta-card">
            <div class="cashier-desktop__meta-label">商户单号</div>
            <div class="cashier-desktop__meta-value">{{ payOrderInfo.mchOrderNo || '--' }}</div>
          </div>
        </div>
      </aside>

      <section class="cashier-desktop__panel">
        <div class="cashier-desktop__section-head">
          <div>
            <h2 class="cashier-desktop__section-title">云闪付支付</h2>
          </div>
        </div>

        <div class="cashier-desktop__method-grid">
          <div class="cashier-desktop__method-card">
            <div class="cashier-desktop__method-icon">
              <img :src="wxImg" alt="云闪付支付" />
            </div>
            <div>
              <div class="cashier-desktop__method-name">云闪付支付</div>
              <div class="cashier-desktop__method-tag">确认订单后继续支付</div>
            </div>
            <div class="cashier-desktop__method-status"></div>
          </div>
        </div>

        <div class="cashier-desktop__footer">
          <button class="cashier-desktop__primary-btn" type="button" @click="pay">继续支付</button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getPayOrderInfo, getPayPackage } from '@/api/api'
import config from "@/config";
export default {

  data: function (){
    return {
      merchantName: '',
      amount: null,
      payOrderInfo: {},
      resData : {},
      wxImg: require("../../assets/images/ysf.jpg"),
      payStatusText: ''
    }
  },
  computed: {
    formattedAmount() {
      if (this.amount === undefined || this.amount === null || Number.isNaN(Number(this.amount))) {
        return '--'
      }
      return Number(this.amount).toFixed(2)
    }
  },

  mounted() {
    this.loadOrderInfo()
  },

  methods: {
    loadOrderInfo() {
      getPayOrderInfo().then(res => {
        this.payOrderInfo = res
        this.merchantName = res.mchName || '商户信息加载中'
        this.amount = res.amount ? res.amount / 100 : null
      }).catch(res => {
        this.$router.push({name: config.errorPageRouteName, params: {errInfo: res.msg}})
      })
    },

    pay: function (){

      if(isNaN(this.amount) || this.amount <= 0){
        return alert('请输入金额');
      }

      let that = this;
      this.payStatusText = '正在发起支付...'
      getPayPackage(this.amount).then(res => {

        if (!window.AlipayJSBridge) {
          document.addEventListener('AlipayJSBridgeReady', function(){
            that.doAlipay(res.alipayTradeNo);
          }, false);
        }else{
          that.doAlipay(res.alipayTradeNo);
        }

      }).catch(res => {
        that.$router.push({name: config.errorPageRouteName, params: {errInfo: res.msg}})
      });
    },


    buildReturnUrlWithOrderInfo(returnUrl) {
      if (!returnUrl) return returnUrl
      try {
        const url = new URL(returnUrl)
        if (this.payOrderInfo.mchOrderNo) {
          url.searchParams.set('bizOrderNo', this.payOrderInfo.mchOrderNo)
        }
        if (this.payOrderInfo.payOrderId) {
          url.searchParams.set('payOrderId', this.payOrderInfo.payOrderId)
        }
        return url.toString()
      } catch (e) {
        return returnUrl
      }
    },

    redirectAfterSuccess(returnUrl) {
      const targetUrl = this.buildReturnUrlWithOrderInfo(returnUrl)
      if (targetUrl) {
        window.setTimeout(() => {
          window.location.href = targetUrl
        }, 600)
      }
    },

    doAlipay(alipayTradeNo){
      const that = this

      // eslint-disable-next-line no-undef
      AlipayJSBridge.call("tradePay", {
        tradeNO: alipayTradeNo
      }, function (data) {
        if ("9000" == data.resultCode) {
          that.payStatusText = '支付成功，正在返回原页面...'
          that.redirectAfterSuccess(that.payOrderInfo.returnUrl)
        } else if (data.resultCode === '8000' || data.resultCode === '6004') {
          that.payStatusText = '支付处理中...'
        } else {
          that.payStatusText = '用户已取消支付'
        }
      });
    },

  }


}
</script>
<style lang="css" scoped>
@import '../cashier-desktop.css';
</style>
